import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'lm-preview-options-dialog',
  templateUrl: './lm-preview-options-dialog.component.html',
  styleUrls: ['./lm-preview-options-dialog.component.scss']
})
export class LMPreviewOptionsDialogComponent implements OnInit {

  @Input() listNames: Array<string>;

  title: string;
  _listName: string;

  get listName(): string {
    return this._listName;
  }

  constructor() { }

  ngOnInit() {
    this.title = Soho.Locale.translate('PreviewDescription');
  }

}
